import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { AdmissionPacketSection } from "@/components/app/admission-packet/packet/packet-section";
import { orpc } from "@/lib/orpc";
import { useCan } from "@/lib/policy";

export const Route = createFileRoute(
  "/_authenticated/_care/residents/$residentId/admission-packet",
)({
  component: AdmissionPacketTab,
});

/** The admission packet, and below it single forms: tracked separately, and never counted towards
 * the admission-packet step of move-in readiness. */
function AdmissionPacketTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const canWrite = useCan("admission:manage", resident.facilityId);
  const shared = { residentId, facilityId: resident.facilityId, canWrite };

  return (
    <div className="space-y-6">
      {/* The sections title themselves at h3; this is the tab's own level. */}
      <h2 className="sr-only">Admission packet</h2>
      <AdmissionPacketSection {...shared} />
      <div className="border-t pt-6">
        <AdmissionPacketSection
          {...shared}
          packetType="single_form"
          title="Single forms"
          description="Run one admission form on its own: any form, at any time, without generating a full packet."
        />
      </div>
    </div>
  );
}
